export const WORK_SHIFT_PATHS = {
  work_shift: 'work_shift',
  work_shift_s: 'sector',
  work_shift_sector: 'sector/:sector_id',
  work_shift_worker_statuses: 'workers_statuses',
  work_shift_brigades: 'brigades',
  work_shift_tickets: 'tickets',
  work_shift_tickets_new: 'tickets-new',
  work_shift_monitoring: 'monitoring',
  work_shift_monitoring_list: 'list',
  work_shift_monitoring_map: 'map',
  work_shift_workers_statuses_page: 'work_shift/sector/:sector_id/workers_statuses',
  work_shift_brigades_page: 'work_shift/sector/:sector_id/brigades',
  work_shift_tickets_page: 'work_shift/sector/:sector_id/tickets',
  work_shift_tickets_new_page: 'work_shift/sector/:sector_id/tickets-new',
  work_shift_monitoring_page: 'work_shift/sector/:sector_id/monitoring',
};
